import React from 'react';

import {
  Example,
  HeroPanelBlock,
  ContentBlockWithTitle,
  ContentBlockWithImage,
  ContentBlockWithText,
  VideoListing,
  ReviewCarousel,
  AccordionBlock,
  WhereToBuyBlock,
  ContactBlock,
  PrimaryHero,
  Infographic,
  RoutineIdentifier,
  RelatedBlogs,
  BodyCopy,
  ProductCardRow,
  FocusContentLink,
  SimpleContentBlock,
  TickerTapeTextBlock
} from '@components';

const ComponentList = {
  'sections.example': Example,
  'sections.hero-panel-block': HeroPanelBlock,
  'sections.content-block-with-title': ContentBlockWithTitle,
  'sections.content-block-with-image': ContentBlockWithImage,
  'sections.content-block-with-text': ContentBlockWithText,
  'sections.video-listing': VideoListing,
  'sections.review-carousel': ReviewCarousel,
  'sections.accordion-block': AccordionBlock,
  'sections.where-to-buy-block': WhereToBuyBlock,
  'sections.contact-block': ContactBlock,
  'sections.primary-hero': PrimaryHero,
  'sections.treatments-infographic': Infographic,
  'sections.routine-identifier': RoutineIdentifier,
  'sections.related-blogs': RelatedBlogs,
  'sections.body-copy': BodyCopy,
  'sections.product-card-row': ProductCardRow,
  'sections.focus-content-link': FocusContentLink,
  'sections.simple-content-block': SimpleContentBlock,
  'sections.ticker-tape-text-block': TickerTapeTextBlock
};

export const createComponent = ({ id, strapiComponent, index, ...data }) => {
  const TagName = ComponentList[String(strapiComponent)];

  if (typeof TagName === `undefined`) {
    return (
      <div key={`dynamic-zone-component-${strapiComponent}-${index}`}>
        Component <b>{strapiComponent}</b> not found
      </div>
    );
  }

  return (
    <TagName
      key={`dynamic-zone-component-${strapiComponent}-${index}`}
      data={data}
    />
  );
};
